import { Modal } from "react-bootstrap";
import React from 'react';
import './ErrorModal.scss';
import { useTranslation } from "react-i18next";
import NVIDIALogo from '../NVIDIALogo/NVIDIALogo';
 
interface LogoutModalProps {
    show: boolean;
    onHide: () => void;
}
const ErrorModal: React.FC<LogoutModalProps> = (LogoutModalProps) => {
    const { t } = useTranslation();
    return (
        <Modal className="error-modal"
            {...LogoutModalProps}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" aria-label={t('SUBMIT_ORDER_ERROR_TITLE')}>
                    <NVIDIALogo fill="#000" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className='text-center error-message' aria-label={t('SOMETHING_WENT_WRONG') + ' ' + t('TRY_AGAIN')}>
                    <span className='error-message-1'>{t('SOMETHING_WENT_WRONG')}</span>
                    <br />
                    <span className='error-message-2'>{t('TRY_AGAIN')}</span>
                </p>
            </Modal.Body>
        </Modal>
    );
}
export default ErrorModal